
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useEffect } from "react";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation("settings");

  // Set initial language to French if not already set
  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (!savedLanguage) {
      changeLanguage('fr');
    }
  }, []);

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className="mr-1"
          aria-label={t('language.switchLanguage')}
        >
          {i18n.language === 'en' ? (
          <span>EN</span>
        ) : (
          <span>FR</span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-background border-border">
        <DropdownMenuItem 
          onClick={() => changeLanguage('fr')}
          className="flex items-center cursor-pointer"
        >
          {/* <FR width={20} height={16} className="mr-2" /> */}
          <span>Français</span>
          {i18n.language === 'fr' && <span className="ml-2 text-primary">✓</span>}
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => changeLanguage('en')}
          className="flex items-center cursor-pointer"
        >
          {/* <GB width={20} height={16} className="mr-2" /> */}
          <span>English</span>
          {i18n.language === 'en' && <span className="ml-2 text-primary">✓</span>}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
